import PaymentSuccess from './paymentSuccess'
export default PaymentSuccess
